<script>
  import { recentlyViewedIds } from './store'
  import { currencyFormat } from './utils'
  // import { placeholderUrl } from '../base/store'
  // import Add2Cart from './Add2Cart.svelte'
  // import ProductAvailability from './ProductAvailability.svelte'
// Prop data
  export let product, maxCol=4
  const col = n => maxCol === n
// Calculated variable
  $: unavailable = !(product.quantity > 0 && product.price > 0)
  $: discount = product.price_before > 0
    ? Math.round((1 - product.price / product.price_before) * 100)
    : 0
  $: viewed = $recentlyViewedIds.indexOf(product.id) > -1
</script>

<li class="catalog-carts__item">
  <a href="{product.url}">
    <div class="arrow-cart">
      <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.07203 0.412346L11.6786 11.0189M11.6786 11.0189L3.22619 10.7124M11.6786 11.0189L11.7115 2.2271"
          stroke="black" stroke-linejoin="round" />
      </svg>
    </div>
    <div class="viewved" class:hidden={!viewed}>
      <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-inside-1_702_443" fill="white">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M0 4.97354C1.23475 2.05096 4.12789 0 7.50005 0C10.8722 0 13.7654 2.05097 15.0001 4.97354C13.7654 7.89611 10.8722 9.94707 7.50005 9.94707C4.12789 9.94707 1.23475 7.89611 0 4.97354Z" />
        </mask>
        <path
          d="M0 4.97354L-0.921162 4.58436L-1.08559 4.97354L-0.921162 5.36272L0 4.97354ZM15.0001 4.97354L15.9213 5.36272L16.0857 4.97354L15.9213 4.58436L15.0001 4.97354ZM0.921162 5.36272C2.00503 2.79727 4.54381 1 7.50005 1V-1C3.71197 -1 0.464471 1.30466 -0.921162 4.58436L0.921162 5.36272ZM7.50005 1C10.4563 1 12.9951 2.79727 14.0789 5.36272L15.9213 4.58436C14.5356 1.30466 11.2881 -1 7.50005 -1V1ZM14.0789 4.58436C12.9951 7.1498 10.4563 8.94707 7.50005 8.94707V10.9471C11.2881 10.9471 14.5356 8.64242 15.9213 5.36272L14.0789 4.58436ZM7.50005 8.94707C4.54381 8.94707 2.00503 7.1498 0.921162 4.58436L-0.921162 5.36272C0.464471 8.64242 3.71197 10.9471 7.50005 10.9471V8.94707Z"
          fill="white" mask="url(#path-1-inside-1_702_443)" />
        <circle cx="7.6184" cy="4.75512" r="1.13989" stroke="white" />
      </svg>
    </div>
    <div class="cart-image__wrap">
      <img src="{product.image}" alt="img">
    </div>
    <div class="cart-content">
      <div class="charateristics-wrap">
        <div class="info-char">
          <div class="icon-info">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <circle cx="7" cy="7" r="6.5" stroke="#181818" />
              <path d="M7 6V10" stroke="#181818" />
              <path d="M7 4V5" stroke="#181818" />
            </svg>
          </div>
          {#if product.rooms}
            <div class=" char rooms-char">
              <p>
                {product.rooms} комнат{product.rooms_suffix}
              </p>
              <span></span>
            </div>
          {/if}
          <div class="char meter-char">
            <p>
              {product.total_area || product.living_area || '?'} м2
            </p>
            <span></span>
          </div>
          {#if product.storey}
            <div class="char floor-char">
              <p>
                {product.storey}/{product.storeys || '?'} этаж
              </p>
            </div>
          {/if}
        </div>
        <div class="geo-char">
          <div class="icon-geo">
            <svg width="13" height="16" viewBox="0 0 13 16" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.5 6.5C12.5 7.26123 12.1493 8.17747 11.556 9.1628C10.9695 10.1369 10.18 11.1232 9.37875 12.0113C8.57928 12.8975 7.77823 13.6749 7.17623 14.2314C6.90277 14.4842 6.67103 14.6908 6.5 14.8406C6.32897 14.6908 6.09723 14.4842 5.82377 14.2314C5.22177 13.6749 4.42072 12.8975 3.62125 12.0113C2.82004 11.1232 2.0305 10.1369 1.44397 9.1628C0.85067 8.17747 0.5 7.26123 0.5 6.5C0.5 3.18629 3.18629 0.5 6.5 0.5C9.81371 0.5 12.5 3.18629 12.5 6.5Z"
                stroke="#181818" />
              <circle cx="6.5" cy="6.5" r="1.5" stroke="#181818" />
            </svg>
          </div>
          <div class="street">
            <p>
              {product.address}
            </p>
          </div>
        </div>
        {#if product.metro_minutes_walk}
          <div class="metro-char">
            <div class="metro-icon">
              <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 8L3.45455 2L5.5 7.2L7.95455 2L10 8" stroke="white" />
              </svg>
            </div>
            <span>
              <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 3.6L6 3.6M6 3.6L3.52258 6M6 3.6L3.52258 1" stroke="black"
                  stroke-linejoin="round" />
              </svg>
            </span>
            <p>
              {product.metro_minutes_walk} мин
            </p>
          </div>
        {/if}
      </div>
      <div class="coast-cart">
        {#if product.price_new}
          <div class="old-price">
            <p>
              {@html currencyFormat(product.price)}
            </p>
          </div>
        {/if}
        <div class="new-price">
          <div class="new-price-val">
            <p>
              {@html currencyFormat(product.actual_price)}
            </p>
          </div>
          <span>
            <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.6" d="M7.52258 1L10 3.6L1 3.6L3.5 6" stroke="black"
                stroke-linejoin="round" />
            </svg>
          </span>
          <div class="new-price__meter">
            <p>
              {@html currencyFormat(product.price_per_meter)}/м2
            </p>
          </div>
        </div>
      </div>
    </div>
  </a>
</li>

